import { BASE_URL_MAP } from "~/core/constants/constants";
import type LxcError from "~/core/models/LxcError.class";
import type { FiltersSelection } from "~/core/models/filters";
import RestService from "~/core/services/rest.service";
import type { BusinessUnit } from "~/modules/businessUnit/models/BusinessUnit.interface";
import type { BusinessUnitUpdate } from "~/modules/businessUnit/models/BusinessUnitUpdate.type";

export class BusinessUnitService extends RestService {
  async getBusinessUnits(
    filter?: string | FiltersSelection,
  ): Promise<BusinessUnit[] | LxcError> {
    let params = {};

    if (filter) {
      params = { ...params, filter };
    }

    return this.$apiV2.get(this.getBusinessUnitsPath(), { params });
  }

  updateBusinessUnit(businessUnit: BusinessUnitUpdate): Promise<BusinessUnit> {
    return this.$apiV2.put(
      this.getBusinessUnitPath(businessUnit.code),
      businessUnit,
    );
  }

  getBusinessUnit(businessUnitCode: number): Promise<BusinessUnit> {
    return this.$apiV2.get(this.getBusinessUnitPath(businessUnitCode));
  }

  getBusinessUnitsPath(): string {
    return BASE_URL_MAP.BUSINESS_UNITS;
  }

  getBusinessUnitPath(businessUnitCode?: number): string {
    if (!businessUnitCode) {
      throw new Error("Business code is undefined");
    }
    return `${this.getBusinessUnitsPath()}/${businessUnitCode}`;
  }
}
export default new BusinessUnitService();
